import request from '@/utils/request'

//获取部门信息
export function getAttendanceGroupListAPI () {
    return request({
      url: `/attendanceGroup/getAttendanceGroupList`,
      method: 'get',
    })
  }

//   获取部门信息
  export function getGroupPersonListAPI (groupId) {
    return request({
      url: `/attendanceUserGroup/getGroupPerson/${groupId}`,
      method: 'get',
    })
  }

//   获取指定人员考勤流水信息
export function getCheckInResultsByUserIdAPI (data) {
    return request({
      url: `/checkInResults/getCheckInResultsByUserId`,
      method: 'POST',
      data,
    })
  }

//   获取指定人员打卡结果
export function getPersonCheckResultsAPI (data) {
    return request({
      url: `/checkInResults/getCheckInResultsStatistics`,
      method: 'POST',
      data,
    })
  }

// 个人打卡结果
  export function getCheckInResultAPI (data) {
    return request({
      url: `/checkInResults/getCheckInResult`,
      method: 'POST',
      data,
    })
  }

  
  export function getAttendanceGroupAPI () {
    return request({
      url: `/attendanceGroup/getAttendanceGroup`,
      method: 'get',
    })
  }

  export function getAttendanceUserAPI () {
    return request({
      url: `/attendanceUserGroup/getAttendanceUser`,
      method: 'get',
    })
  }



// WEBPACK FOOTER //
// ./src/api/Attendance.js